import classes from './CoachOnboardingDismissModal.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Modal from '../../../common/Modal'
import classNames from 'classnames'
import { setIsModalOpen } from '../../../../reducers/coachOnboardingReducer'
import { ReactComponent as FlagIcon } from '../../../../assets/images/common/icons/Flag.svg'
import { updateOnboardingStatus } from '../../../../actions/coachOnboardingActions'


const CoachOnboardingDismissModal = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const currentUser = useSelector(state => state.user.current_user)
  const isOpen = useSelector(state => state.coachOnboarding.isModalOpen)

  const handleClose = () => dispatch(setIsModalOpen(false))
  const dismissOnboarding = () => {
    handleClose()
    dispatch(updateOnboardingStatus({ userId: currentUser.id, actionType: 'dismiss' }))
  }

  return (
    <Modal
      isOpen={isOpen}
      contentLabel={t('dashboard.coach.onboarding.coachOnboardingDismissModal.contentLabel')}
      className={classes.modalWrapper}
      onClose={handleClose}
    >
      <div className={classNames(classes.modalContent, 'd-flex flex-column justify-content-center align-items-center')}>
        <div className={classNames(classes.flagContainer, 'd-flex justify-content-center align-items-center')}>
          <FlagIcon width={44} height={44} color='white' />
        </div>
        <h4 className={classes.title}>{t('dashboard.coach.onboarding.coachOnboardingDismissModal.title')}</h4>
        <p className={classNames(classes.message, 'text-center')}>
          {t('dashboard.coach.onboarding.coachOnboardingDismissModal.message')}
        </p>
        <button
          className={classNames(classes.dismissButton, 'btn btn-primary')}
          onClick={dismissOnboarding}
        >
          {t('dashboard.coach.onboarding.coachOnboardingDismissModal.dismissButton')}
        </button>
        <button
          className={classNames(classes.cancelButton, 'btn btn-secondary')}
          onClick={handleClose}
        >
          {t('common.cancel')}
        </button>
      </div>
    </Modal>
  )
}

export default CoachOnboardingDismissModal
